module.exports = __webpack_public_path__ + "img/ic_scb.c8c57894.jpg";